import {getQueryParams} from '@wix/music-shared/dist/src/utils/queryParams/queryParams';

export const getInstance = (): string => {
  const {instance} = getQueryParams();
  if (!instance) {
    throw new Error('No instance in query params');
  }
  return instance;
};
